<div *ngIf="!hasUserAccess">
    <app-request-access-view></app-request-access-view>
</div>

<div *ngIf="hasUserAccess">
    <app-solicitud-credito-viewer-workflow (closeSolicitud)="closeSolicitudCredito()"></app-solicitud-credito-viewer-workflow>
</div>